import request from '@/system/engine/request';
import config from '@/system/engine/config';
import {getLocalStorage} from '@/system/store/localstorage';

export function home(){
	var language = (getLocalStorage('currentLang')) ? getLocalStorage('currentLang') : 'cn';
	const data = request({
		url: config.url+'home?language='+language,
		method: 'get'
	});

	return Promise.resolve(data);
}


